/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationWizardStylesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationWizardStylesQuery = { organisationWizardStyles?: { __typename: 'OrganisationWizardStylesResult', fontFaceDefinitions?: string | null, fontFamily?: string | null, fontSizeGroupTitle?: string | null, fontWeightGroupTitle?: string | null, fontSizeQuestionPrompt?: string | null, fontWeightQuestionPrompt?: string | null, fontSizeOptionLabel?: string | null, fontWeightOptionLabel?: string | null, fontSizeButtonText?: string | null, fontWeightButtonText?: string | null, primaryColor?: string | null, secondaryColor?: string | null, selectedColor?: string | null } | null };

export type SetOrganisationWizardCustomStylesMutationVariables = Types.Exact<{
  input: Types.SetOrganisationWizardCustomStylesInput;
}>;


export type SetOrganisationWizardCustomStylesMutation = { setOrganisationWizardCustomStyles: { __typename: 'SetOrganisationRepresentativeResult', organisation: { __typename: 'ViewerOrganisation', id: string } } };


export const OrganisationWizardStylesDocument = gql`
    query OrganisationWizardStyles {
  organisationWizardStyles {
    fontFaceDefinitions
    fontFamily
    fontSizeGroupTitle
    fontWeightGroupTitle
    fontSizeQuestionPrompt
    fontWeightQuestionPrompt
    fontSizeOptionLabel
    fontWeightOptionLabel
    fontSizeButtonText
    fontWeightButtonText
    primaryColor
    secondaryColor
    selectedColor
  }
}
    `;

/**
 * __useOrganisationWizardStylesQuery__
 *
 * To run a query within a React component, call `useOrganisationWizardStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWizardStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationWizardStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationWizardStylesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>(OrganisationWizardStylesDocument, options);
      }
export function useOrganisationWizardStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>(OrganisationWizardStylesDocument, options);
        }
export function useOrganisationWizardStylesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>(OrganisationWizardStylesDocument, options);
        }
export type OrganisationWizardStylesQueryHookResult = ReturnType<typeof useOrganisationWizardStylesQuery>;
export type OrganisationWizardStylesLazyQueryHookResult = ReturnType<typeof useOrganisationWizardStylesLazyQuery>;
export type OrganisationWizardStylesSuspenseQueryHookResult = ReturnType<typeof useOrganisationWizardStylesSuspenseQuery>;
export type OrganisationWizardStylesQueryResult = Apollo.QueryResult<OrganisationWizardStylesQuery, OrganisationWizardStylesQueryVariables>;
export const SetOrganisationWizardCustomStylesDocument = gql`
    mutation SetOrganisationWizardCustomStyles($input: SetOrganisationWizardCustomStylesInput!) {
  setOrganisationWizardCustomStyles(input: $input) {
    organisation {
      id
    }
  }
}
    `;
export type SetOrganisationWizardCustomStylesMutationFn = Apollo.MutationFunction<SetOrganisationWizardCustomStylesMutation, SetOrganisationWizardCustomStylesMutationVariables>;

/**
 * __useSetOrganisationWizardCustomStylesMutation__
 *
 * To run a mutation, you first call `useSetOrganisationWizardCustomStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganisationWizardCustomStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganisationWizardCustomStylesMutation, { data, loading, error }] = useSetOrganisationWizardCustomStylesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrganisationWizardCustomStylesMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganisationWizardCustomStylesMutation, SetOrganisationWizardCustomStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganisationWizardCustomStylesMutation, SetOrganisationWizardCustomStylesMutationVariables>(SetOrganisationWizardCustomStylesDocument, options);
      }
export type SetOrganisationWizardCustomStylesMutationHookResult = ReturnType<typeof useSetOrganisationWizardCustomStylesMutation>;
export type SetOrganisationWizardCustomStylesMutationResult = Apollo.MutationResult<SetOrganisationWizardCustomStylesMutation>;
export type SetOrganisationWizardCustomStylesMutationOptions = Apollo.BaseMutationOptions<SetOrganisationWizardCustomStylesMutation, SetOrganisationWizardCustomStylesMutationVariables>;